import { Email, Location, Phone } from '@public';

import { CONSTANT } from '@/constants';

import styles from './supportDetails.module.scss';

export const SupportDetails = () => {
	return (
		<>
			<div className={styles.section}>
				<Phone customStyles={styles['section-icon']} />
				<div className={styles['section-text']}>
					<p className={styles['section-title']}>Phone</p>
					<p data-testid="phone">{CONSTANT.WATERIQ_PHONE_NUMBER}</p>
				</div>
			</div>
			<div className={styles.section}>
				<Email customStyles={styles['section-icon']} />
				<div className={styles['section-text']}>
					<p className={styles['section-title']}>Email</p>
					<p data-testid="email">{CONSTANT.WATERIQ_EMAIL_ADDRESS}</p>
				</div>
			</div>
			<div className={styles.section}>
				<Location customStyles={styles['section-icon']} />
				<div className={styles['section-text']}>
					<p className={styles['section-title']}>Location</p>
					<p data-testid="location">{CONSTANT.WATERIQ_LOCATION}</p>
				</div>
			</div>
		</>
	);
};
